<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Bild med bildtext
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Bildblock med valfri bildtext nedan. Används i teknikartiklar för att
      illustrera steg och detaljer.
    </p>

    <PreviewFull label="Exempel">
      <figure class="m-0 w-full">
        <div
          class="w-full rounded-[20px] overflow-hidden"
          style="
            aspect-ratio: 16/9;
            background: linear-gradient(
              135deg,
              #d1faf5 0%,
              #99f0e5 50%,
              #14b8a6 100%
            );
          "
        >
          <div class="w-full h-full flex items-center justify-center">
            <span
              class="font-[Poppins] font-bold text-[15px] text-teal-700 opacity-60"
              >Bildplacering</span
            >
          </div>
        </div>
        <figcaption
          class="mt-3 font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] leading-[1.5] italic"
        >
          Degytans texturer efter 30 minuter autolys. Notera hur ytan blivit
          blank och glutensträngar är synliga vid försiktig sträckning.
        </figcaption>
      </figure>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<figure class="m-0 w-full">
  <img
    src="..."
    alt="Beskrivning"
    class="w-full rounded-[20px] object-cover"
    style="aspect-ratio: 16/9"
  />
  <figcaption class="mt-3 font-[Plus_Jakarta_Sans] text-[13px] text-[#6c7a77] leading-[1.5] italic">
    Bildtexten visas här.
  </figcaption>
</figure>`;

const cssCode = `/* Bild */
border-radius: 20px;   /* rounded-[20px] */

/* Bildtext */
font-family: 'Plus Jakarta Sans', sans-serif;
font-style: italic;
font-size: 13px;
color: #6c7a77;
line-height: 1.5;

/* Bildtext-marginal */
margin-top: 12px;   /* mt-3 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
